import { render, staticRenderFns } from "./Optik.vue?vue&type=template&id=d7a0f1ce&"
import script from "./Optik.vue?vue&type=script&lang=js&"
export * from "./Optik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports